import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { ConfiguracionInicialService } from 'src/app/services/configuracioninicial.service';
import { MenuService } from 'src/app/services/menu.service';
import { UtilitariosService } from 'src/app/services/utilitarios.service';
import { ConfiguracionService } from '../../services/configuracion.service';
import { RespuestaGenerica } from '../../models/generic/RespuestaGenerica';
import { ConfirmacionGenericaComponent } from '../confirmaciongenerica/confirmaciongenerica.component';
import { TamanoAppService } from 'src/app/services/tamanoapp.service';
import { Item_Seleccion } from 'src/app/models/generic/Item_Seleccion';
import { Maestros_SectorService } from '../../services/maestros_sector.service';
import { Maestros_RolesDominioService } from '../../services/maestros_rolesdominio.service';
import { Maestro_EstadoActualizar } from 'src/app/models/generic/Maestro_EstadoActualizar';
import { Maestro_RolesDominio } from 'src/app/models/generic/Maestro_RolesDominio';

@Component({
  selector: 'maestros-rolesdominio-editar',
  templateUrl: './maestros-rolesdominio-editar.component.html',
  styleUrls: ['./maestros-rolesdominio-editar.component.scss']
})
export class MaestrosRolesDominioEditarComponent implements OnInit{
  form: FormGroup;
  tituloForma: string = 'Registro de rol dominio';
  tituloBoton: string = 'Registrar rol dominio';
  mostrarCargando: boolean = false;
  parametrosPrincipal: Maestro_RolesDominio;
  codigoAccion: string = '';
  @ViewChild('appconfirmacion', {static: false}) _appconfirmacion: ConfirmacionGenericaComponent;
  idTabSeleccionado: number = 0;
  _EditarItemsVisualizar: string = '';
  listaEstado: Maestro_EstadoActualizar[] = [];
  
  constructor(public router: Router,
    public fb: FormBuilder,
    public cd: ChangeDetectorRef,
    public snackbar: MatSnackBar,
    public utilitariosService: UtilitariosService,
    public configuracionInicialService: ConfiguracionInicialService,
    public menuService: MenuService,
    public datosServices: Maestros_RolesDominioService,
    public configuracionService: ConfiguracionService,
    public tamanoAppService: TamanoAppService) {}

  ngOnInit() {
    this.IniciarFormulario();
    this.listaEstado = [];
    this.listaEstado.push({ seleccionado: true, descripcion: 'Si' });
    this.listaEstado.push({ seleccionado: false, descripcion: 'No' });
  }
  ngAfterViewInit() {
    if (this.utilitariosService.VerificarContieneDatos(this.menuService.ParametrosAdicionales)) {
      this.parametrosPrincipal = JSON.parse(this.menuService.ParametrosAdicionales);

      // console.log('setea valor', this.parametrosPrincipal);
      this.form.setValue(this.parametrosPrincipal);
      
      this.tituloForma = 'Edición de rol dominio';
      this.tituloBoton = 'Editar rol dominio';
    } else {
      this.tituloForma = 'Registro de rol dominio';
      this.tituloBoton = 'Registrar rol dominio';
      this.parametrosPrincipal = new Maestro_RolesDominio();
      this.parametrosPrincipal.id = 0;
    }
  }

  IniciarFormulario() {
    this.form = this.fb.group({
      id: [0],
      rol: ['', [Validators.required, Validators.maxLength(100)]],
      activo: [true]
    });
  }
  CancelarRegistro() {
    this.menuService.CambiarComponenteActivo('MaestrosRolesDominioComponent');
  }
  ConfirmoUsuario(confirmo: boolean) {
    if (confirmo) {
      if (this.codigoAccion === 'guardar') {
        this.ActualizarRegistro();
      }
    }
  }
  Guardar() {
    if (this.form.valid) {
      this.codigoAccion = 'guardar';
      this._appconfirmacion.MostrarMensajeConfirmacion();
    } else {
      this.utilitariosService.MostrarErroresFormulario(this.form);
    }
  }
  ActualizarRegistro() {
    this.mostrarCargando = true;

    this.datosServices.Actualizar(this.form.value)
            .subscribe((resp: RespuestaGenerica) =>{
              this.mostrarCargando = false;
              if (resp.procesoExitoso == false) {
                this.utilitariosService.MensajeToast(resp.mensaje);
              } else {
                this.menuService.CambiarComponenteActivo('MaestrosRolesDominioComponent');
              }
            },
            (error: Error) => {
              this.utilitariosService.ObtenerMensajeErrorRespuesta(error);
              this.mostrarCargando = false;
              this.cd.detectChanges();
            },
            () => this.cd.detectChanges());
  }
  tabSeleccionado(item: any) {
    this.idTabSeleccionado = item.index;    
  }
}
